import axios from '../services/api.service';

export const viewCreateOne = async (data: object) => {
  try {
    await axios.post('/views', data);
    return {message: 'success', err: null};
  } catch (error) {
    return {message: null, err: error};
  }
};